// extracted by mini-css-extract-plugin
export default {"notificationHub":"yYwXl","unReadNotification":"_1PaUX","loader":"_118th","small":"_3EN0a","big":"p9nNZ","notificationsContainer":"nSUIf","seeMore":"SJLfV"};